












































































































































































































































































import {
  ticketClient,
  authorClient,
  client,
  collectionServiceClient,
} from "@/api/index";
import {
  GetVoipQICaseReq,
  GetVoipQICaseListReq,
  SaveVoipQICaseReq,
  AudioMarkText,
  VoipQICaseData,
  GetRobotCorpusMarkCaseReq,
  SaveRobotCorpusMarkCaseReq,
  //   RobotCorpusMarkData,
  RobotDialog,
  DialogMark,
} from "@/pbjs/xcommon/collection_pb.js";
import {
  QualityReport,
  QualityObject,
  SimInfo,
  RobotCorpusMarkData,
  Ticket,
} from "@/pbjs/xcommon/ticket_pb.js";
import {
  GetVoipQITicketListReq,
  GetTicketListReq,
  BatchAssignTicketReq,
  BatchRecycleTicketReq,
  BatchEntrustTicketReq,
  RollApplyTicketReq,
  ReduceTicketReq,
  GetTicketListParamReq,
  CloseTicketReq,
  Bool,
  GetAudioQualityRuleListReq,
  AudioQualityRuleData,
} from "@/pbjs/external/ticket/ticket_pb";
import { timeFormat, downloadFile, setValue } from "@/utils/index";
import {
  SearchUserReq,
  BatchGetLoginInfoReq,
  GetOutSourceInfoReq,
} from "@/pbjs/external/user/user_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, handleResponse, setPage, errorMsg } from "@/utils/request";
import { Sort, Rank } from "@/pbjs/xcommon/common_pb";
import { Component, Prop, Provide, Vue, Watch } from "vue-property-decorator";
@Component({
  name: "ApplicationReview", //"ManualUpgradeTicketDialogue",
  components: {
    Copywriting: () => import("./components/Copywriting.vue"),
    // Qualityinspectionlabel: () =>
    //   import("./orderDeal/components/Qualityinspectionlabel.vue"),
  },
})
export default class ApplicationReview extends Vue {
  // @Prop() recotData!: any;
  // @Prop() sopeRow!:any;
  @Provide() private pagnition: any = pagnition;
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 10;
  @Provide() private pagerCount: number = 0;
  @Provide() private itemId: any = "";
  @Provide() private callrecordid: any = "";
  @Provide() private audioPlayLoading: Boolean = false;
  @Provide() private disabled: Boolean = false;
  @Provide() private disabledSubmit: Boolean = false;
  @Provide() private MachineQuality: any = "";
  @Provide() private isfix: Boolean = false;

  @Provide() private timelong: number = 0;
  @Provide() private audio: any = [];
  @Provide() private recotData: any = [];
  @Provide() private resultData: any = []; // 列表结果
  @Provide() private caseresultListData: any = [];
  @Provide() private caseresultListDataS: any = [];
  @Provide() private aa: any = [];
  @Provide() private offsetY: number = 0;
  @Provide() private showDialogType: any = 0;
  @Provide() private ManualUpgradeTicketDialogueForm: any = {
    OverdueDay: "",
  };
  @Provide() private rules: any = {
    OverdueDay: [
      { required: true, message: "Pls enter a number value", trigger: "blur" },
    ],
  };
  // lee 手动升级操作的接口请求是否完成，布尔值
  @Provide() private inputValue: any = [];
  @Provide() private urgeusername: any = "";
  @Provide() private caseid: any = "";
  @Provide() private disableQ: boolean = false;
  @Provide() private isshowButton: boolean = false;
  @Provide() private isGetManualUpgradeTicketActionDone: boolean = false;
  @Provide() private Aging: any = "";
  @Provide() private status: any = "";
  @Provide() private selectTextId: any = "";
  @Provide() private selectText: any = "";
  @Provide() private humanscore: any = "";
  @Provide() private aiscore: any = "";
  @Provide() private cn: any = "";
  @Provide() private flag: boolean = false;
  @Provide() private tags: any = [
    { name: "标签一", type: "" },
    { name: "标签二", type: "success" },
    { name: "标签三", type: "info" },
    { name: "标签四", type: "warning" },
    { name: "标签五", type: "danger" },
  ];
  @Provide() private part: any = "";
  @Provide() private finalscoreList: any = "";
  @Provide() private AudioMarkTextList: any = [];
  @Provide() private savecheckedRuleList: any = [];
  @Provide() private intentmapMap: any = [];
  @Provide() private getContent: any = "";

  @Provide() private sliderValue: any = [100, 20, 48];
  @Provide() private calltextList: any = [{}];
  @Provide() private title: any = "";
  @Provide() private caseresult: any = "";
  @Provide() private audiorecordurl: any = "";
  @Provide() private calldirection: any = "";
  @Provide() private hangupcause: any = "";
  @Provide() private starttimestamp: any = "";
  @Provide() private dialinfo: any = {};
  @Provide() private isCheckednormal: boolean = false;
  @Provide() private isChangeUserIntent: boolean = false;
  @Provide() private timestart: any = "";
  @Provide() private timeend: any = "";
  @Provide() private Copywritingindex: any = "";
  @Provide() private positionwith: any = "";
  @Provide() private checkedRuleid: any = [];
  @Provide() private checkedRule: any = [];
  @Provide() private checkedNodes: any = [];
  @Provide() private humanqualityList: any = [];
  @Provide() private selectTextStartIndex: number = 0;
  @Provide() private selectTextEndIndex: number = 0;
  @Provide() private content: any = "";
  @Provide() private coloeObj: any = {};
  @Provide() private statusId: any = "";
  @Provide() private UserIntent: any = "";
  @Provide() private selectedText: any = "";
  @Provide() private isshowinput: boolean = true;
  @Provide() private showcorr: boolean = false;
  @Provide() private widthPop: boolean = false;

  @Provide() private RecotdinCheckList: any = [
    { label: "dashbordDy.normal" },
    { label: "dashbordDy.AbusiveCustomer" },
    { label: "dashbordDy.sop" },
    { label: "dashbordDy.CustomerPromises" },
  ];
  @Provide() private dynamicTags: any = [[], [], [], []];
  @Provide() private selectedIndex: any = -1;
  @Provide() private selectionStart: any;
  @Provide() private selectionEnd: any;
  // cyp标注数据发送给后端
  @Provide() private colorfulMark: any = [];
  @Provide() private colorfulContent: any = [];
  private created(): void {
    this.itemId = this.$route.query.id;
    this.title = this.$route.query.title;
    this.statusId = this.$route.query.status;
    this.callrecordid = this.$route.query.callrecordid;
    this.getVoipQICaseReq(this.itemId);
    this.getAudio(this.callrecordid);
    // 按钮宽度不同语言适配
    this.cn = localStorage.getItem("cn");
    if (this.cn == "id-ID") {
      this.positionwith = "440px";
    } else if (this.cn == "en-US") {
      this.positionwith = "240px";
    } else if (this.cn == "zh-CN") {
      this.positionwith = "250px";
    }
    var clientWidth = document.body.clientWidth;
    if (1536 < clientWidth && clientWidth <= 2560) {
      this.widthPop = true;
      // document.getElementById('widthPop')?.style
    } else {
      this.widthPop = false;
    }
  }
  private mounted() {
    (document as any).body.onmouseup = (event: any) => {
      this.blur();
      event.stopImmediatePropagation();
    };
  }
  private focunsCon() {
  }
  private Copywriting(event: any, item: any, index: any) {
    const e = event || window.event;
    e.stopPropagation();
    this.part = "part" + item.sentence;
    this.timestart = item.timestart;
    this.timeend = item.timeend;
    this.Copywritingindex = index;
  }

  //校验
  private testValue() {
    //isChangeUserIntent是否修改意图

    let arr: any = [];
    this.calltextList.forEach((item: any, index: any) => {
      if (item.role == "customer") {
        arr.push(item.isChangeUserIntent);
      }
    });
    if (arr.findIndex((index: any) => index === true) === -1) {
      return true;
    } else {
      this.$message({
        type: "error",
        message: this.$tc("dashbordDy.modifyIntent"), // "dont choose the same rule!",
      });
      return false;
    }
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.$emit("refreshTable", this.pageIndex, this.pageSize);
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.$emit("refreshTable", this.pageIndex, this.pageSize);
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.$emit("refreshTable", this.pageIndex, this.pageSize);
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.$emit("refreshTable", this.pageIndex, this.pageSize);
  }
  private hideManualUpgradeTicketDialogue(val: any) {
    this.showDialogType = val;
  }

  private CorpusOpen(id: any, num: any) {
    this.showDialogType = 2;
    this.selectTextId = id;
    this.isChangeUserIntent = this.calltextList[id].isChangeUserIntent;
    this.getContent = this.calltextList[id].text;
    this.UserIntent = this.calltextList[id].intent;
    if (num == 3 || num == 4) {
      this.isshowinput = false;
    } else {
      this.isshowinput = true;
    }
  }
  private saveMetaData() {
    this.SaveVoipQICaseReqRequest();
  }
  private closeTag(tag: any, index: any) {
    if (this.statusId !== 4) {

      this.colorfulMark[index].splice(this.colorfulMark[index].indexOf(tag), 1);
      this.$forceUpdate();
    }
  }
  private saveAudioMarkText(val: any) {

    if (val) {
      this.calltextList[val.val].isChangeUserIntent = false;

      this.calltextList[val.val].intent = (this.$refs
        .Copywriting as any).UserIntentB;
      let num = (this.$refs.Copywriting as any).UserIntentB;
      this.intentmapMap.forEach((item: any, index: any) => {
        item.intentmapList.forEach((i: any, n: any) => {
          if (i.intentid == num) {
            this.calltextList[val.val].intentValue = i.intentname;
          }
        });
      });
      //如果变化
      if (
        this.calltextList[val.val].showText !==
        (this.$refs.Copywriting as any).correctcopywritingB
      ) {
        // this.showcorr
        this.calltextList[val.val].showcorr = true;
        // this.colorfulMark[val.val] = [];
      }
      this.calltextList[val.val].fixtext = (this.$refs
        .Copywriting as any).correctcopywritingB;
      this.calltextList[val.val].showText = (this.$refs
        .Copywriting as any).correctcopywritingB;
      this.colorful();
    }
  }

  // 添加到颜色标记数组
  private repaymentTime(
    event: any,
    item: any,
    index: any,
    color: any,
    type: any
  ) {
    if (!this.colorfulMark[index]) {
      this.colorfulMark[index] = [];
    }


    if (
      this.selectedText.length ==
      Math.abs(this.selectionEnd - this.selectionStart)
    ) {
      let star;
      let end;
      if (this.selectionStart < this.selectionEnd) {
        star = this.selectionStart + 1;
        end = this.selectionEnd + 1;
      } else {
        star = this.selectionEnd + 1;
        end = this.selectionStart + 1;
      }
      this.colorfulMark[index].push({
        color: color,
        start: star,
        end: end,
        key: type,
        value: this.selectedText,
      });
      this.colorful();
      this.blur();
    } else {
      this.$message.error("El valor seleccionado es incorrecto");
    }
  }
  // 根据颜色标记渲染文字
  private colorful() {
    //   this.colorfulMark.forEach((item: any, indexI: number) => {
    //     if (item) {
    //       item.sort((obj1: any, obj2: any) => {
    //         return obj2.start - obj1.start;
    //       });
    //       let sentence = this.calltextList[indexI].text;
    //       item.forEach((colorObj: any) => {
    //         const strBefore = sentence.slice(0, colorObj.start);
    //         const strAfter = sentence.slice(colorObj.end);
    //         const strMiddle = sentence.slice(colorObj.start, colorObj.end);
    //         sentence = `${strBefore}<span style="color:${colorObj.color}">${strMiddle}</span>${strAfter}`;
    //       });
    //       this.colorfulContent[indexI] = sentence;
    //     }
    //   });
  }
  //废弃规则
  // private goRecodingDetailPage(row: any, index: any) {

  //   this.caseresultListData.forEach((item: any, indexe: any) => {
  //     if (indexe == index) {
  //       item.status = 2;
  //       item.changeFlag = true;
  //     }
  //   });
  //   // this.SaveVoipQICaseReqRequest(4, row);
  // }
  // 处理鼠标选中
  private getContenttext(event: any, index: any) {
    if (this.statusId !== 4) {
      const e = event || window.event;
      const selectTextId: any = (document as any).getSelection().anchorNode
        .parentNode.id;
      this.selectTextId = selectTextId;
      //   const selectText: any = (document as any).getSelection().toString();
      //   this.selectText = selectText;
      //   const selectTextStartIndex: any = (document as any).getSelection()
      //     .anchorOffset; //获取划过的文字在文本中的起始位置
      //   const selectTextEndIndex: any = (document as any).getSelection()
      //     .focusOffset; //获取划过的文字在文本的结束位置
      //   this.selectTextStartIndex = selectTextStartIndex;
      //   this.selectTextEndIndex = selectTextEndIndex;
      //   //  if (selectTextId1=='') {
      //   //    this.offsetX.forEach((item:any,index:any) => {
      //   //      this.$set(this.offsetX,index,false)
      //   //    });
      //   //  }
      //   const element = (document as any).getElementsByClassName("postion");
      //   element[index].style.left = e.offsetX + "px";
      //   element[index].style.top = e.offsetY + 20 + "px";
      //   if (e.offsetX && e.offsetY) {
      //     this.$set(this.offsetX, index, true);
      //     e.stopPropagation();
      //   }

      const selectionObj = (document as any).getSelection();
      const selectedText: any = selectionObj.toString();
      if (selectedText) {
        this.selectedIndex = index;
        this.selectedText = selectedText;
        this.selectionStart = selectionObj.anchorOffset;
        this.selectionEnd = selectionObj.focusOffset;
        const selectedParentNode = event.target.parentNode;
        const element = selectedParentNode.getElementsByClassName("postion")[0];
        element.style.left = event.offsetX + "px";
        element.style.top = event.offsetY + 20 + "px";
        event.stopPropagation();
      } else {
        this.blur();
      }
    }
  }
  //s失焦
  private blur() {
    this.selectedIndex = -1;
    this.selectionStart = undefined;
    this.selectionEnd = undefined;
  }
  //获取质检工单详情
  private getVoipQICaseReq(id: any) {
    let request: any = new GetRobotCorpusMarkCaseReq();
    request.setCommonin(setCommon());
    request.setTicketid(Number(id));
    request.setItemid(105); //Number(row.itemid)
    collectionServiceClient.getRobotCorpusMarkCase(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          let _fuc = this.getVoipQualityInspectionCaseFuc;
          handleResponse(data, _fuc);
        }
        if (err) {
          if (err.code == 16) {
            this.$router.push("./login");
          } else {
            this.$message.error(err.errmsg || err.message);
          }
        }
      }
    );
  }

  // 获取列表数据
  private getVoipQualityInspectionCaseFuc(data: any) {
    this.recotData = data;
    // this.calldirection = data.dialinfo.calldirection;
    this.Aging = data.data.caselevel;
    this.caseid = data.dialinfo.orderid;
    this.urgeusername = data.data.urgeusername;
    this.status = data.data.ticketstatus;
    this.hangupcause = data.dialinfo.hangupcause;
    this.intentmapMap = data.data.intentnodeList;
    data.dialinfo.dialogoriginalList.forEach((item: any) => {
      item.offsetX = false;
      item.isChangeUserIntent = true;
      item.fixtext = item.text;
      item.showText = item.text; //修改之前的对话
    });
    //如果是已完成status==4
    if (data.data.ticket.status == 4) {
      this.statusId = 4;
      this.colorfulMark = [];
      data.data.dialogmarkList.forEach((a: any, p: any) => {
        this.colorfulMark.push(a.dialogmarkList);
        a.showcorr = a.fixtext !== a.text ? true : false;
        this.intentmapMap.forEach((item: any, index: any) => {
          item.intentmapList.forEach((i: any, n: any) => {
            if (i.intentid == a.intent) {
              a.intentValue = i.intentname;
            }
          });
        });
      });
      this.calltextList = data.data.dialogmarkList;
    } else {
      this.calltextList = data.dialinfo.dialogoriginalList;
    }

    // cyp根据后端数据解析
    // this.colorfulMark = xxxxx
    this.colorful();
  }

  private SaveVoipQICaseReqRequest() {
    if (this.testValue()) {
      this.isCheckednormal = true;
      let request: any = new SaveRobotCorpusMarkCaseReq();
      let objData: any = new RobotCorpusMarkData();
      let arr: any = [];
      this.calltextList.forEach((item: any, index: any) => {
        let audioMarkText: any = new RobotDialog();
        audioMarkText.setRole(item.role);
        audioMarkText.setText(item.text); //Number(item.Label) + 1
        audioMarkText.setIntent(item.intent + ""); //SpeechId
        audioMarkText.setTime(item.time);
        audioMarkText.setFixtext(item.fixtext);
        let arr1: any = [];
        if (this.colorfulMark[index]) {
          this.colorfulMark[index].forEach((i: any, a: any) => {
            // if (a == index) {
            let qualityReport: any = new DialogMark();
            qualityReport.setStart(Number(i.start));
            qualityReport.setEnd(Number(i.end));
            qualityReport.setKey(i.key + "");
            qualityReport.setValue(i.value);
            arr1.push(qualityReport);
            // }
          });
        }

        audioMarkText.setDialogmarkList(arr1);
        arr.push(audioMarkText);
      });
      objData.setDialogmarkList(arr);
      let ticktReq = new Ticket();
      ticktReq.setId(Number(this.itemId));
      ticktReq.setStatus(4); //this.statusId
      objData.setTicket(ticktReq);
      // objData.addMarktext(audioMarkTextList)
      request.setCommonin(setCommon());
      request.setData(objData);
      collectionServiceClient.saveRobotCorpusMarkCase(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            let data: any = response.toObject();
            if (data.commonout.code == 0) {
              this.$message.success("success");
              this.isCheckednormal = false;
              this.getVoipQICaseReq(this.$route.query.id);
              this.$route.query.status = "4";
            } else {
              this.isCheckednormal = false;

              this.$message.error(
                data.commonout.errmsg || data.commonout.message
              );
            }
          }
          if (err) {
            this.isCheckednormal = false;

            if (err.code == 16) {
              this.$router.push("./login");
            } else {
              this.$message.error(err.errmsg || err.message);
            }
          }
        }
      );
    }
  }
  private audioPlay1(val: any) {
    this.audioPlay(val.val, val.index, val.timeend);
  }
  // lee 录音文件播放
  private async audioPlay(val: any, index: number, timeend: number) {
    var audio: any = document.querySelector("audio");
    audio.duration;
    audio.currentTime = val;
    var audioFunc = function() {
      audio.play();
      if (audio.currentTime >= timeend) {
        audio.pause();
        audio.removeEventListener("timeupdate", audioFunc);
      }
    };
    audio.addEventListener("timeupdate", audioFunc);
  }
  // lee 获取录音文件
  private async getAudio(callrecordid: any) {
    // row.videoLoading = true;
    this.audioPlayLoading = true;
    this.disabledSubmit = true;
    const { getDialListMediaV2 }: any = await import("@/request/getDialList");
    let _arg = {
      VOIPRecordID: callrecordid,
    };
    let response = await getDialListMediaV2(_arg);
    if (response && response.right) {
      // row.videoLoading = false;
      // row.videoShow = true;
      this.audioPlayLoading = false;
      this.disabledSubmit = false;
      this.audiorecordurl =
        "data:" + response.mediaheader + ";base64," + response.mediabody;
    }
  }
  private hideMaskVue() {
    this.$emit(
      "hideManualUpgradeTicketDialogue",
      false
    );
  }
}
